import { Box, Skeleton, Tab, Tabs, Typography } from "@mui/material";
import { useQuery } from "urql";
import { tokenQuery } from "../../support/mutations";
import {
  TokenAcccordionDetailsMethodMobile,
  TokenAcccordionDetailsMethod,
} from "./TokenAccordionDetailsMethod";
import { useState } from "react";
import { CopyBlock, codepen as theme } from "react-code-blocks";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      sx={{ width: { xs: "85vw", sm: "100%" } }}
      {...other}
    >
      {value === index && <>{children}</>}
    </Box>
  );
}

const TokenAccordionDetails = ({ token, open }) => {
  const [value, setValue] = useState(0);
  const [{ data, fetching, error }] = useQuery({
    query: tokenQuery,
    variables: { address: token.address },
    pause: !open,
  });
  const tokenData = data?.token;
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {error && <p>Oh no... {error.message}</p>}
      {tokenData && (
        <>
          {token.description && (
            <Typography variant="subtitle2">{token.description}</Typography>
          )}
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Methods" {...a11yProps(0)} />
            <Tab
              label="Source Code"
              {...a11yProps(1)}
              disabled={!token.verifiedAt || !tokenData?.code}
            />
          </Tabs>
          <CustomTabPanel value={value} index={0}>
            {tokenData.methods
              .sort(
                (a, b) =>
                  a.sigs[0].signature[0].charCodeAt() -
                  b.sigs[0].signature[0].charCodeAt()
              )
              .map((method) =>
                window.location.host.includes("localhost") ? (
                  <TokenAcccordionDetailsMethod
                    token={token}
                    method={method}
                    key={method.key}
                  />
                ) : (
                  <TokenAcccordionDetailsMethodMobile
                    method={method}
                    key={method.key}
                  />
                )
              )}
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            {tokenData?.code &&
              tokenData.code.reverse().map((contract) => (
                <>
                  <Typography variant="caption">{contract.filename}</Typography>
                  <CopyBlock
                    key={contract.filename}
                    customStyle={{
                      fontSize: "10px",
                      height: "500px",
                      overflow: "scroll",
                    }}
                    //wrapLongLines={true}
                    text={contract.content}
                    language={"javascript"}
                    showLineNumbers={true}
                    startingLineNumber={1}
                    //wrapLines={true}
                    theme={theme}
                  />
                </>
              ))}
          </CustomTabPanel>
        </>
      )}
      {fetching && <Skeleton variant="rectangular" height={500} />}
    </>
  );
};

export default TokenAccordionDetails;
